import { createReducer, on } from '@ngrx/store';
import {
  deleteFile,
  getLoadedState,
  getSubscription,
  loadedProfile,
  loadedSubscription,
  loadedWorkflow,
  removeWorkflowById,
  resetSubscription,
  saveAppProfile,
  saveFileToWorkflow,
  saveProfile,
  saveResultToWorklow,
  saveSubscription,
  saveWorkflow,
  setErrorState,
  updateAppProfile,
  updateAppProfileByKey,
  updateWorkflow,
} from './state.actions';
import { initialLoadedState, initialWorkflowState } from './state.state';
import { WorkflowData } from '../types/types';

export const workflowReducer = createReducer(
  initialWorkflowState,

  // Subscription

  on(getSubscription, (state) => ({ ...state })),

  on(saveSubscription, (state, { subscription }) => ({
    ...state,
    subscription: subscription,
  })),

  // Profile

  on(saveProfile, (state, { profile }) => ({
    ...state,
    profile: profile,
  })),

  on(updateAppProfileByKey, (state, { key, value }) => ({
    ...state,
    profile: {
      ...state.profile,
      appProfile: {
        ...state.profile.appProfile,
        [key]: value,
      },
    },
  })),

  on(updateAppProfile, (state, { appProfile }) => ({
    ...state,
    profile: {
      ...state.profile,
      appProfile: appProfile,
    },
  })),

  on(saveAppProfile, (state, { appProfile }) => ({
    ...state,
    profile: {
      ...state.profile,
      appProfile: appProfile,
    },
  })),

  // Conversation / GenAi

  on(saveResultToWorklow, (state, { modelResponse }) => ({
    ...state,
    workflow: {
      ...state.workflow,
      promptWorkflow: {
        ...state.workflow?.promptWorkflow,
        aiResults: {
          ...state.workflow?.promptWorkflow.aiResults,
          ...modelResponse,
        },
      },
    },
  })),

  // Workflow

  on(saveWorkflow, (state, { workflowPayload, workflowId }) => {
    let basicWorkflowData = state.subscription.workflowData;

    basicWorkflowData = basicWorkflowData.map((entry) => {
      if (entry.uid !== workflowId) {
        return entry;
      } else {
        return {
          ...entry,
          name: workflowPayload.name,
          status: workflowPayload.status,
          activeStep: workflowPayload.activeStep,
          step: workflowPayload.step,
        };
      }
    });

    return {
      ...state,
      workflow: {
        ...state.workflow,
        name: workflowPayload?.name || '',
        status: workflowPayload?.status || '',
        step: workflowPayload?.step,
        activeStep: workflowPayload?.activeStep,
        promptWorkflow: workflowPayload?.promptWorkflow,
        resultEditing: workflowPayload?.resultEditing,
      },
      subscription: {
        ...state.subscription,
        workflowData: basicWorkflowData,
      },
    };
  }),

  on(updateWorkflow, (state, { workflow }) => ({
    ...state,
    workflow: workflow,
  })),

  on(removeWorkflowById, (state, { workflowId }) => ({
    ...state,
    subscription: {
      ...state.subscription,
      workflowData: state.subscription.workflowData.filter(
        (workflow) => workflow.uid !== workflowId,
      ),
    },
  })),

  on(setErrorState, (state, { error }) => {
    return {
      ...state,
      error: error,
    };
  }),

  // on(saveFileToWorkflow, (state, { process }) => {
  //   if (state.workflow.promptWorkflow.uploadedFiles) {

  //     var uploadedFiles = [...state.workflow.promptWorkflow.uploadedFiles];
  //     const index = uploadedFiles.findIndex(file => file.uid === process.uid)

  //     if (index !== -1) {
  //       uploadedFiles[index] = {...uploadedFiles[index]}
  //       uploadedFiles[index].status = process.status;
  //       uploadedFiles[index].result = process.result;
  //       return {
  //         ...state,
  //         workflow: {
  //           ...state.workflow,
  //           promptWorkflow: {
  //             ...state.workflow.promptWorkflow,
  //             uploadedFiles: [
  //               ...uploadedFiles
  //             ]
  //           }
  //         }
  //       }
  //     }

  //     else {
  //       uploadedFiles.push(process)
  //       return {
  //         ...state,
  //         workflow: {
  //           ...state.workflow,
  //           promptWorkflow: {
  //             ...state.workflow.promptWorkflow,
  //             uploadedFiles: uploadedFiles
  //           }
  //         }
  //       }
  //     }
  //   }

  //   else {
  //     return {
  //       ...state,
  //       workflow: {
  //         ...state.workflow,
  //         promptWorkflow: {
  //           ...state.workflow.promptWorkflow,
  //           uploadedFiles: [process]
  //         }
  //       }
  //     }
  //   }
  // }),

  on(saveFileToWorkflow, (state, { process }) => {
    const uploadedFiles = state.workflow.promptWorkflow.uploadedFiles || [];
    const index = uploadedFiles.findIndex((file) => file.uid === process.uid);

    const updatedFiles =
      index !== -1
        ? [
            ...uploadedFiles.slice(0, index),
            {
              ...uploadedFiles[index],
              status: process.status,
              result: process.result,
            },
            ...uploadedFiles.slice(index + 1),
          ]
        : [...uploadedFiles, process];

    return {
      ...state,
      workflow: {
        ...state.workflow,
        promptWorkflow: {
          ...state.workflow.promptWorkflow,
          uploadedFiles: updatedFiles,
        },
      },
    };
  }),

  on(deleteFile, (state, { file, workflow }) => {
    return {
      ...state,
      workflow: {
        ...state.workflow,
        promptWorkflow: {
          ...state.workflow.promptWorkflow,
          uploadedFiles: state.workflow.promptWorkflow.uploadedFiles.filter(
            (uploadedFile) => uploadedFile.name !== file.name,
          ),
          aiResults: {
            ...state.workflow.promptWorkflow.aiResults,
            fileSummary: '',
          },
        },
      },
    };
  }),
);

// Loaded State

export const loadedReducer = createReducer(
  initialLoadedState,

  on(getLoadedState, (state) => ({ ...state })),

  on(loadedSubscription, (state, {}) => ({
    ...state,
    subscription: true,
  })),

  on(resetSubscription, (state, {}) => ({
    ...state,
    subscription: false,
  })),

  on(loadedProfile, (state, {}) => ({
    ...state,
    profile: true,
  })),

  on(loadedWorkflow, (state, {}) => ({
    ...state,
    // workflow: true,
  })),
);
